'use strict';
var parent = require('../stable/parse-int');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/actual/parse-int.js
// module id = 549
// module chunks = 13